import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { retrieveEmailPreferences, updateEmailPreferences } from '../apis/email';
import { initialSurveyEmailTableData } from './tableData';
import { setupHandleSurveyRetrieve } from '../apis/common';
import { BannerContext, BannerProvider } from '../contexts/BannerContext';
import { addAnalyticEvent } from '../analytics/common';
import { unsubscribeFromAllEmail, unsubscribeFromAllEmailError } from '../analytics/email';
import ErrorBoundary from '../contexts/ErrorBoundary';

import { RetrieveErrorContext } from '../contexts/RetrieveErrorContext';
import MarketingPreferencesCard from './common/MarketingPreferencesCard';
import { determineMessage } from '../../utils/general';

export const surveySaveChangeButton = 'survey-save-change';

export function Preferences({ email }) {

  const { openErrorAlert, openSuccessAlert, closeSuccessAlert, } = React.useContext(BannerContext);
  const { addError } = React.useContext(RetrieveErrorContext);
  const [selected, setSelected] = React.useState([]);
  const [tableData, setTableData] = React.useState(initialSurveyEmailTableData());
  const handleRetrieve = setupHandleSurveyRetrieve(tableData, setTableData, setSelected);

  function handleError() {
    openErrorAlert();
  }

  function handleRetrieveError() {
    addError();
  }

  function handleSuccess(res) {
    openSuccessAlert(determineMessage(selected, tableData), email);
    handleRetrieve(res);
  }

  React.useEffect(() => {
    retrieveEmailPreferences(email, handleRetrieve, handleRetrieveError);
  }, []);

  const clickSaveChanges = () => {
    if (selected.length) {
      closeSuccessAlert();
      updateEmailPreferences(email, selected, tableData,
        (res) => {
          addAnalyticEvent(unsubscribeFromAllEmail);
          handleSuccess(res);
        }, (err) => {
          addAnalyticEvent(unsubscribeFromAllEmailError);
          handleError(err);
        });
    }
  };

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">SURVEY EMAILS</Typography>
      <Typography variant="body-base" height="none">
        To make changes to your survey preferences, click on the individual preference below.
      </Typography>
      <MarketingPreferencesCard
        tableData={tableData}
        setTableData={setTableData}
        setSelected={setSelected}
      />
      <div className="sui-grid sui-grid-cols-8">
        <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
        <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3 sui-grid sui-gap-y-4">
          <Button aria-label={surveySaveChangeButton} fullWidth onClick={clickSaveChanges}>
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
}

function SurveyEmailPreference({ email }) {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences email={email} />
      </BannerProvider>
    </ErrorBoundary>
  );
}

export default SurveyEmailPreference;

const proptypes = {
  email: PropTypes.string.isRequired,
};

SurveyEmailPreference.propTypes = proptypes;
Preferences.propTypes = proptypes;
